import React, { useState } from "react";
import axios from "axios";
import {
	Button,
	Dialog,
	DialogTitle,
	DialogContent,
	makeStyles,
	createStyles,
} from "@material-ui/core";

import Certificate from "./Certificate";
import { CircularProgress } from "@material-ui/core";

const useStyles = makeStyles((theme) =>
	createStyles({
		paper: {
			width: "100%",
			maxWidth: 800,
		},
		openTable: {
			marginLeft: "10px",
		},
		headerDialog: {
			"& h2": {
				display: "flex",
				justifyContent: "space-between",
			},
		},
		circ: {
			marginLeft: "5px",
		},
	})
);

export default function CertificationsDialog({ dialogProps, title, state }) {
	const [spreadsheetUrl, setSpreadsheetUrl] = useState(null);
	const [loading, setLoading] = useState(false);
	const cls = useStyles();
	// keys = user emails
	const keys = Object.keys(state);
	const url = process.env.REACT_APP_FUNCTIONS_generateTableCertificates_URL;

	const generateTable = () => {
		console.log(url);
		setLoading(true);
		setSpreadsheetUrl(null);
		axios.get(url).then((res) => {
			if (res.status < 400 && res.data && res.data.status === "success") {
				setSpreadsheetUrl(res.data.spreadsheetUrl);
			}
			console.log(res);
		}).catch((err) => {
			console.error("Error while generating excel file: ", err.data);
		}).finally(() => {
			setLoading(false);
		});
	};

	return (
		<Dialog
			{...dialogProps}
			classes={{
				paper: cls.paper,
			}}>
			<DialogTitle className={cls.headerDialog}>
				Сертифікати
				<div>
					<Button
						variant="outlined"
						color="inherit"
						size="small"
						onClick={() => generateTable()}
						disabled={loading}>
						Згенерувати звіт
						{loading && <CircularProgress size={20} className={cls.circ} />}
					</Button>
					{spreadsheetUrl && (
						<a
							className={cls.openTable}
							target="_blank"
							rel="noopener noreferrer"
							href={spreadsheetUrl}>
							<Button variant="outlined" size="small" color="secondary">
								Відкрити таблицю
							</Button>
						</a>
					)}
				</div>
			</DialogTitle>
			<DialogContent dividers>
				{keys.length
					? keys.map((key, i) => (
						<Certificate
							key={key + i}
							email={key}
							renderData={state[key].renderData}
						/>))
					: "Сертифікатів не знайдено!"}
			</DialogContent>
		</Dialog>
	);
}
